var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[_c('v-card',{staticClass:"mx-auto mt-10 rounded-br-xl rounded-tl-xl",attrs:{"elevation":"19","max-width":"600px"}},[_c('v-card-text',[_c('coor-to-geo-json')],1)],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }